import getCSVColumns from "@/utils/get-csv-columns";
import FormFileInput from "@babackapp/react-hook-forms-components/form-file-input";
import { FormField } from "@babackapp/ui/components/form";
import { useFormContext } from "react-hook-form";
import { ShopImportFormValues } from "./import-settings-form-types";

type ExampleFileInputProps = {
  onLoad?: (b: boolean) => void;
};

export default function ExampleFileInput({ onLoad }: ExampleFileInputProps) {
  const { control, setValue } = useFormContext<ShopImportFormValues>();

  async function onChange(
    e: React.ChangeEvent<HTMLInputElement> | FileList | null,
  ) {
    if (e === null) {
      setValue("options.exampleFile", null);
      setValue("mapping", []);
      return;
    }
    onLoad?.(true);
    const file = e instanceof FileList ? e[0] : e?.target.files?.[0];
    if (!file) return;
    const parsedColumns = await getCSVColumns(file);
    setValue("options.exampleFile", file.name);
    setValue(
      "mapping",
      parsedColumns.map((column) => ({
        mapTo: null,
        fieldIndex: column.fieldIndex,
        fieldName: column.fieldName,
        exampleValue: column.exampleValue,
      })),
    );
    onLoad?.(false);
  }

  return (
    <FormField
      control={control}
      name="options.exampleFile"
      render={({ field }) => (
        <FormFileInput
          label="Example file"
          description="Upload a file with the same structure as the import file to help us understand how to map the columns."
          fileName={field.value}
          value={field.value ?? "Select a file"}
          accept=".csv"
          onChange={onChange}
        />
      )}
    />
  );
}
